"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRollbarCaptureEvent = useRollbarCaptureEvent;

var _tinyInvariantEsmA43f84cc = require("./tiny-invariant.esm-a43f84cc.js");

var _constant = require("./constant.js");

var _useRollbar = require("./useRollbar.js");

var _utilsB8accee = require("./utils-b8accee6.js");

require("./_rollupPluginBabelHelpers-e84dd01a.js");

require("react");

require("./Provider.js");

require("rollbar");

function useRollbarCaptureEvent(metadata) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constant.LEVEL_INFO;
  (0, _tinyInvariantEsmA43f84cc.i)((0, _utilsB8accee.i)(level), "".concat(level, " is not a valid level setting for Rollbar"));
  var rollbar = (0, _useRollbar.useRollbar)();
  useEffect(function () {
    rollbar.captureEvent(metadata, level);
  }, [metadata, level, rollbar]);
}